"use client";

import NextLink from "next/link";
import { Text, Link as ChakraLink } from "@chakra-ui/react";
import { brandFont } from "@/app/lib/font";
import { brand_name } from "@/app/constants";

export function BrandName() {
  return (
    <ChakraLink as={NextLink} href={"/"} _hover={{ textDecoration: "none" }}>
      <Text
        className={brandFont.className}
        fontSize={{ base: "lg", md: "xl" }}
        fontWeight="bold"
        letterSpacing="0.04em"
      >
        {brand_name}
      </Text>
    </ChakraLink>
  );
}
